export default __webpack_public_path__ + "static/media/game3_active.29aecf94.png";